module.exports={
    common:{
        connect:"連線",
        contactUs:"聯絡我們",
        learnMore:"進一步瞭解",
        trustedBy:"信任",
        sendSuccess:"傳送成功!",
        sendFail:"傳送失敗!",
        lang:[
            {
                value:"EN",
                name:"英文"
            },{
                value:"CHT",
                name:"繁中"
            },{
                value:"CN",
                name:"簡中"
            },{
                value:"JP",
                name:"日文"
            }
        ]
    },
    bannerTips:{
        square:"超過一百萬平方英尺的製造空間",
        production:"精簡了世界各地的生產設施",
        processes:"永續製程和環保材料"
    },
    footer:{
        letStarted:"立即使用",
        signTitle:"註冊以收取新的訊息",
        signPlaceholder:"電子郵件信箱地址",
        signBtn:"傳送",
        signTips:"您可以隨時選擇停止接收此類電子郵件。您提供的資訊會受到 MPT Solution (HK) Limited 的隱私權原則和條款規範",
        privacyPolicy:"隱私權原則",
        cookiePolicy:"Cookie 原則",
        termsOfUse:"使用條款",
        copyright:"Copyright © 2021 MPT Solution and its Affiliates and Subsidiaries. All rights reserved",
        emailrRquired:"郵箱不能為空!",
        emailVaild:"郵箱格式不對!",
    },
    home:{
        worldMolding:{
            title:"世界級塑膠部件生產商",
            text:"品質卓越， MPT solution是世界一流的外觀塑膠件生產商"
        },
        dell:{
            title:"「效能卓越及致力於服務機構 DGP」",
            text:"Dell Inc. 的 WWP Client NB Mechanical"
        },
        sevices:{
            title:"服務",
            text:"漢達精密提供高度精準的全面性機構解決方案。我們提供各種服務，例如模具設計、材質選擇、最佳化製程以及更多的服務。"
        },
        injectMold:{
            title:"射出成型",
            text:"漢達精密擁有超過五千個客製模具案例和超過二十年的生產經驗，可以提供的服務不限於製造機構部件。"
        },
        metal:{
            title:"金属加工",
            text:"漢達精密擁有完整的金屬件製造能力。"
        },
        finishing:{
            title:"外觀處理",
            text:"漢達精密提供各式各樣的加工處理，為您的機構產品提供一站式服務。"
        }
    },
    aboutUs:{
        title:"我們是漢達精密",
        introText:{
            no1:"漢達精密自 1999 年起持續為全球領先業界的各企業開發精密機構部件。",
            no2:"漢達精密使用最先進的技術，生產精密的，高品質的、高良率的，美觀的複合材料機構部件。除產品的品質外，我們同時加強了客戶服務。讓漢達精密充滿創新的專屬團隊承接您的下一個構想，並將其化為現實。",
            no3:"在此深入了解我們的服務和核心競爭力。",
        },
        here:"在此",
        whyWorkWithUs:"與我們合作的理由",
        history:{
            title:"集團歷史",
            textNo1:"MiTAC Precision Technology Corporation (MPT Solution)創立於 1999 年，現在已成為擁有世界一流的設計與製造能力的機構部件供應商，並擁有多年為國際大型客戶提供服務的經驗，包括國內外的領先企業和主要的原始設備製造商／原始設計製造商 (OEM/ODM)。",
            textNo2:"2007 年，漢達與臺灣的上市公司神基科技正式合併，並以雄厚的資本和研發電子產品的能力為後盾，為顧客提供更完整的機構部件整合解決方案。",
            textNo3:"2009 年，投資了世界第三大鎂鋁合金製造公司 Waffer ，進一步增強了漢達精密的輕金屬機構部件的製造能力。"
        }
    },
    affiliates:{
        title:"關係企業",
        introText:"漢達精密是 Getac Group 的子公司，而Getac Group是一家於 1989 年建立的跨國企業集團。Getac Group 的業務規模涵蓋消費性電子產品、IT 通道、系統整合、軟體開發、石化工業、工業氣體和食物加工產業"
    },
    coreCompetencies:{
        title:"核心競爭力",
        prototypingServices:{
            title:"模型設計:",
            textList:[
                '3D列印（塑膠&金屬）',
                'CNC',
                '軟膠鑄造模',
                '金屬沖壓',
                '外觀處理',
                '簡易模具'
            ]
        },
        manufacturingServices:{
            title:"製造服務:",
            textList:[
                '模具自製',
                '大量製造',
                '小批量生產',
                '表面處理',
                '單件組裝和整機模組組裝',
                '包裝',
                '工業自動化 (A.I.+IoT)'
            ]
        },
        integrationSolutions:{
            title:"整合解決方案:",
            textList:[
                '系統整合聯合開發',
                'CMF 聯合開發',
                '機構部件聯合開發',
                '製造程序開發',
                '材料開發'
            ]
        },
        testingCertification:{
            title:"測試和認證:",
            textList:[
                '機構部件測試',
                '塑膠材料測試',
                '環境模擬',
                '區域安全認證'
            ]
        }
    },
    sustainability:{
        title:"可持續發展",
        carbonFootprint:"「碳足跡」已成為全球各大企業深入研究和探索的環境保護趨勢之一。因此，MPT Corp. 持續在履行其與環境保護有關的企業管理職責。",
        pdaComponent:"漢達精密自 2011 年 4 月開始使用「PDA 組件」產品，成功執行了碳足跡計畫。根據《碳足跡計算準則》(Carbon Footprint Calculation Guideline)，DPA 組件產品在整個生命週期中會產生 8.741kg CO2e/unit的溫室氣體。在原材料、製造和運輸三個階段中，製造階段會產生大部分的碳排放，佔總排放量的 82.12%，其次是原材料階段的 17.87%，運輸階段則佔 0.01%。此情形表示想要真正實現環境保護，即必須加強產品製造階段的綠色處理計劃。",
        frontrunner:"漢達精密為環保道路上的先行者，已經積累了為客戶提供服務的雄厚實力，將能與客戶攜手創造更環保的產品。"
    },
    integrityManagement:{
        title:"誠信經營",
    },
    sustainableReport:{
        title:"永續報告",
        csrTitle:"CSR報告書",
        zcTitle:"政策與宣言"
    },
    technologySolutions:{
        title:"技術解決方案",
        introText:"漢達精密採用最先進的技術，提供高品質、高產能與美觀的機構部件，滿足客戶的個性化需求。創新化的量產技術，使我們可以精準地高效的實現您的期望。"
    },
    injectionMolding:{
        title:"射出成型",
        introText:"漢達精密是高品質射出成型服務的業界領導者。我們有超過五千套客製模具製作和二十年以上的成型生產經驗，提供的不僅僅是精密機構部件產品，更能滿足您對最具挑戰性的客製化產品的需求。我們提供從設計模具，到成品生產的完整的解決方案。"
    },
    cosmeticFinishing:{
        title:"表面處理",
        introText:"漢達精密具有各類型的表面處理技術，滿足您對於各種外觀的高標準要求。"
    },
    metalFabrication:{
        title:"金屬加工",
        introText:"漢達精密擁有完備的處理金屬板材製程的能力。"
    },
    composite:{
        title:"複合材料",
        introText:"漢達精密解決方案使我們的客戶可以使用複合材料設計與製造出更輕巧及更堅韌的零件。"
    },
    material:{
        title:"材料",
        introText:"漢達精密是經過認證的消費後樹脂 (Post Consumer Resin, PCR) 製造商。我們擁有完整的專利佈局，從材料開發、製程設計，延伸至驗證和屬性測試。"
    },
    capabilities:{
        trustedBy:"信任",
        ourCapabilities:{
            title:"我們的能力",
            introText:"漢達精密採用最先進的技術，根據客戶的個別需求，提供高品質、高產量與美觀的機構部件。我們獨特、先進的製造工藝和創新的批量生產技術，使我們可以精準地實現您的期望。我們在亞洲擁有多個製造工廠，並擁有二十多年的經驗，可以為世界領先之公司提供全面的機構部件解決方案。在此深入瞭解我們的核心競爭力。",
            fullList:"完整的設備清單"
        },
        engineeringConsulting:{
            title:"工程與諮詢",
            introText:"我們擁有兩百多位元經認證的工程師以及二十多年開發精密機構部件的經驗，有能力可以協助您提高開發速度與降低成本。"           
        },
        certifications:{
            title:"認證",
            introText:"漢達精密已通過 ISO 和 IATF 認證。品質是我們的首要任務。 深入瞭解我們的認證。"
        },
        massProduction:{
            title:"量產",
            introText:"在過去二十多年，漢達精密一直與世界領先的公司合作，做為其專屬的精密機構部件合作夥伴。"
        },
        automation:{
            title:"自動化",
            introText:"漢達精密是在業界內較早引入自動化生產系統的企業之一。我們可以透過自動化系統加快生產速度。"
        }
    },
    certifications:{
        title:"認證",
        itemList:[
            "通過 TUV 的 ISO 9001 認證（2007 年）",
            "通過 TUV 的 ISO14001 認證（2007 年）",
            "通過 TUV 的 OHSAS18000 認證（2007 年）",
            "獲得 NIK 的綠色供應商認證（2010 年）",
            "Canon 認證的 GP（2010 年）",
            "通過 BSI 的 ISO 9001 認證（2010 年）",
            "通過 BSI 的 ISO 14001 認證（2010 年）",
            "通過 BSI 的 ISO 18001 認證（2010年）",
            "Canon 認證的 GP（2013 年）",
            "通過 BSI 的 ISO14001 認證（2013 年）",
            "通過 BSI 的 ISO 18001 認證（2013 年）",
            "通過 BSI 的 ISO 9001 認證（2013 年）",
            "通過 SGS 的 TS 16949 認證（2014 年）",
            "通過 BSI 的 ISO14001 認證（2016 年）",
            "通過 BSI 的 ISO 18001 認證（2016 年）",
            "通過 SGS 的 ISO 9001 認證（2018 年）",
            "通過 SGS 的 IATF16949 認證（2018 年）",
            "通過 BSI 的 ISO 45001 認證（2018 年）",
            "通過 BSI 的 OHSAS18001 認證（2018 年）",
            "SONY 綠色合作夥伴證書的通知（2019 年）",
            "TUV 授予經 RBA 驗證的評估計畫金獎（2020 年）"
        ]
    },
    engineeringConsulting:{
        title:"每一個設計都包含卓越和創新",
        introText:"漢達精密認為創新是企業成長的關鍵。讓我們協助您取得競爭優勢、承接您的下一個構想，並將其化為現實。"
    },
    testingLab:{
        title:"測試實驗室",
        introText:"漢達精密擁有經中國合格評定國家認可委員會 (CNAS) 認可之檢測實驗室（實驗室編號：L5893）。我們大量投資於機構件的相關研究與開發，擁有設備齊全的測試實驗室可以提供材料和產品的全面性分析測試。",
        mechanical:{
            title:"機械性能測試:",
            text:   "• 拉伸和彎曲測試<br>"+
                    "• 夏氏和艾氏衝擊試驗<br>"+
                    "• 拉力降服和伸長率測試<br>"+
                    "• 微視硬度<br>"+
                    "• 合金材料之金相分析與失效分析<br>"+
                    "• 安裝和拋光<br>"+
                    "• 掃描式電子顯微鏡<br>"+
                    "• 微結構和元素分析"
        },
        material:{
            title:"塑膠材料測試:",
            text:"• 熱重分析儀 (TGA) <br> "+
                "• 微分掃描卡計 (DSC) <br>" +
                "• 傅立葉轉換紅外光譜儀 <br>"+
                "• 熱變形溫度測試儀 (HDT及Vicat) <br>"+
                "• 熔體流動速率 <br>"+
                "• 燃燒性能測試試驗（UL 測試）<br>"+
                "• 加工和流變性質（HAAKE 流變儀）"
        },
        environmental:{
            title:"環境模擬: ",
            text:   "• 中性鹽霧測試 <br>"+
                    "• 恆溫恆濕測試 <br>"+
                    "• 冷熱衝擊測試"
        },
        other:{
            title:"其他測試:",
            text:   "• 電化學工作站 <br>"+
                    "• 光澤度測試 <br>"+
                    "• 鉛筆表面硬度測試 <br>"+
                    "• RCA 測試 <br>"+
                    "• 色差儀 <br>"+
                    "• 電阻率測試 <br>"+
                    "• 蕭氏硬度測試"
        }
    },
    prototyping:{
        title:"模型設計",
        introTtile:"讓方案變成現實",
        introText:"製作模型從未如此容易。讓我們協助您以無可比擬的速度設計高精度和高品質的模型！",
        tips:"漢達精密的原型製作中心可以提供各種高分辨率的快速原型製作解決方案，例如 CNC、3D 列印、氨基甲酸乙酯鑄件和熱壓成型等。"
    },
    locations:{
        title:"全球據點",
        introText:"漢達精密擁有的數百位全職設計人員，皆秉持著對精密零件製造業務的熱情和專業知識，致力開發創新的製造程序與材料，以因應任何挑戰。<br>先進的工程與全球製造地點:"
    },
    FAQ:{
        title:"常見問題",
        introText:"有問題嗎？我們會在此回答！如果您沒有在此部分看到您的問題，請透過我們的聯絡頁面傳送訊息給我們。"
    },
    contactUs:{
        title:"聯絡我們",
        firstName:"名字",
        lastName:"姓氏",
        email:"電子郵箱",
        message:"訊息",
        additionalDetails:"其他資訊",
        sendMessage:"傳送訊息",
        howHelp:"我們能如何協助您？",
        trustedBy:"信任"
    },
    privacyPolicy:{
        title:"隱私權原則",
        A:{
            title:"A. 本隱私權注意事項",
            textItem:[
                "MPT Solution (HK) Limited 及其子公司 (MPT Solution) 致力於保護個人和個人敏感資料的隱私，且必須遵守《2018 年英國資料保護法》和《歐盟一般資料保護規則》(GDPR)，以及全世界其他國家的類似相關法律。本隱私權注意事項已構成漢達精密義務的一部分，以便能公開與公平地處理漢達精密處理的所有個人和個人敏感資料，並提供與處理個人資料之方式及用途有關的詳細資訊。",            
                "漢達精密會處理其客戶和合作夥伴的個人資料，例如姓名、聯絡方式和電子信箱地址等。處理資料係指收集、儲存、使用、揭露或處置個人資料。",
                "利用漢達精密的解決方案和服務，或使用漢達精密網站的現有或潛在客戶和合作夥伴的個人，可能會收到進一步的隱私權注意事項，且此類注意事項可能是包含在單獨的增補通知中。此類額外的隱私權注意事項應做為補充本隱私權注意事項的內容。",
                "本隱私權注意事項與漢達精密處理個人資料有關。除另有說明外，本文件中提及之所有「我方」或「我方的」，應指所有處理個人或個人敏感資料的漢達精密業務線。本隱私權注意事項的對象為本組織以外與我方互動的個人，包括消費者和我方網站的瀏覽者（合稱為「您」）。本隱私權注意事項中使用的定義術語會在下文 (Q) 節中闡明。",
                "MPT Solution為本隱私權注意事項的資料控制者。聯絡方式，請參見下文第 (N) 節。",
                "本隱私權注意事項將會不時進行修訂或更新，以反映我方處理個人資料之做法的改變或適用法律的變更。我方鼓勵您詳細閱讀本隱私權注意事項及定期查看本頁面，以審查我方可能會根據本隱私權注意事項之條款進行的任何變更。",
                "本隱私權注意事項中提供之清單或範例皆非詳盡無疏漏或完全代表每一個人。"
            ],
            scope:{
                title:"範圍",
                textItem:[
                    "本隱私權注意事項之範圍，包括現有／潛在之客戶與合作夥伴的下列個人資料：",
                    "•&nbsp;&nbsp;&nbsp;&nbsp;收集個人資料 <br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;處理個人資料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;使用個人資料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;揭露個人資料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;國際資料傳輸<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;資料正確性<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;資料最小化<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;保留個人資料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;保障個人資料<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;資料主體權利<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;Cookie<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;聯絡方式<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;投訴"
                ]
            }
        },
        B:{
            title:"B. 收集您的個人資料",
            textItem:[
                "我方可能會收集與您有關的個人資料，例如您的姓名、地址和聯絡方式。我方可能會收集個人資料的來源，包括：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您提供給我方的個人資料（例如您聯絡我方時的電子郵件、電話或任何其他方式）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;您在我方與您的正常關係中提供給我方的個人資料（例如：您向我方購買產品或服務）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;您明示選擇公開的個人資料，包括透過社交媒體選擇公開您的個人資料以供查看。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方從第三方（例如合作夥伴、信用參考機構和執法機關等）取得的個人資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在您造訪任何漢達精密網站（「網站」），或使用網站本身或透過其提供之任何功能或資源時，我方取得與您有關的個人資料。在您造訪網站時，您的裝置和瀏覽器自動揭露的某些資訊（例如裝置類型、作業系統、瀏覽器類型、瀏覽器設定、IP 位址、語言設定、連線至網站的日期和時間，以及其他技術通訊資訊）。",
                "我方也可能會建立與您有關的個人資料，例如您與我方的互動記錄，以及購買歷史記錄的詳細資料，涵蓋：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;個人詳細資料：姓名、偏好名稱、性別、出生日期／年齡、國籍、照片。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;聯絡方式：送貨地址、電話號碼、電子信箱地址、社交媒體的個人檔案詳細資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;付款詳細資料：帳單地址、銀行帳號或信用卡號碼、持卡人或帳戶持有人姓名、卡片或帳戶安全性詳細資料、卡片的生效日期、卡片的到期日。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;觀點和意見：您選擇傳送給我方的任何觀點和意見，或在社交媒體平台上公開發表與我方有關的觀點和意見。"
            ]
        },
        C:{
            title:"C. 處理您的個人資料",
            textItem:[
                "我方得使用以下內容做為處理您的個人資料之合法依據。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您已經事先向我方明確表示，僅同意針對完全自願之事項處理您的個人資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;該處理為您可能與我方簽訂之任何合約的相關必要事項。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;適用法律要求的處理，或<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方擁有為了管理、經營或促進我方業務之目的進行處理的合法利益，且該合法利益不會與您的利益、基本權利或自由發生衝突。"
            ]
        },
        D:{
            title:"D. 使用您的個人資料",
            textItem:[
                "我方得為下列目的而使用您的個人資料：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;運營和管理我方的網站：為您提供內容、顯示廣告和其他資訊，以及透過我方的網站與您進行溝通和互動。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;為您提供產品和服務：為您提供我方的網站和其他服務、提供您購買的產品、依據您的要求提供促銷商品、針對前述產品和服務與您進行溝通。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;行銷通訊：透過任何方式（包括透過電子郵件、電話、簡訊、社交媒體、郵寄或親自）寄送您可能感興趣的新項目和其他資訊，但是必須確保依據適用法律為您提供此類通訊。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;通訊和 IT 營運：管理我們的通訊系統、IT 安全性營運以及 IT 安全性稽核。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;健康和安全性：評估健康和安全性與保存記錄，以及遵守相關的法律義務。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;財務管理：銷售、財務、公司稽核、廠商管理。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;調查：與您接觸以了解您對我方之的產品和服務的意見。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;改善我方的产品和服务：确认现有产品和服务的问题、计画改进现有的产品和服务、创造新的产品和服务。"
            ]
        },
        E:{
            title:"E. 揭露個人資料",
            textItem:[
                "我方可能會將您的個人資料揭露予 Getac 集團中的其他實體（包括為您提供服務和經營我方的網站）。",
                "此外，我方可能會將您的個人資料揭露給以下人員：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;法律和監管機構，依據要求或為了報告任何實際或涉嫌違反適用法律或法規的行為。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;會計師、稽核員、律師和其他漢達精密的外部專業顧問，是必須遵守具有約束力的保密合約義務。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;漢達精密的經銷商、分銷商和第三方業務夥伴，以便在簽訂合約之前，依據您的要求採取措施或履行合約。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;世界各地的第三方處理者（例如付款服務供應商、航運公司、電話行銷公司、資料供應服務供應商、資料清理服務供應商等），但是必須符合本第 (E) 節中所述之要求。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相關方、執法機構或法院，在建立、行使或捍衛法律權利的必要範圍內。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相關方為預防、調查、偵查或起訴刑事犯罪或執行刑事處罰之目的，包括保障對於公共安全具有約束力的合約保密義務和防止對其造成威脅。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;任何相關的第三方收購者，如果我方出售或轉讓我方業務或資產的全部或任何相關部分（包括在重組、解散或清算的情況下）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;使用第三方外掛程式或內容，在我方網站上提供社交媒體平台的第三方供應商（例如 LinkedIn、YouTube 和 Facebook）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方聘請第三方處理者處理您的個人資料時，該處理者將會受具有約束力之合約義務的約束，以便：<br/>•&nbsp;&nbsp;&nbsp;&nbsp;僅依據我方之事先書面指示處理個人資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;採取措施保護個人資料的保密性和安全性，以及適用法律的其他任何要求。" 
            ]
        },
        F:{
            title:"F. 個人資料的國際傳輸",
            textItem:[
                "由於我方業務具有國際性質，可能需要依據本隱私權注意事項中規定之目的，在 Getac 集團內部傳輸您的個人資料以及傳輸給上文第 (D) 節所述的第三方。因此，我方可能會將您的個人資料傳輸至法律和資料保護合規性要求可能與您所在國家不同的其他國家。將包括在歐洲經濟區 (EEA) 以外傳輸、處理和儲存個人資料。",
                "我方將會根據《標準個資保護契約條款》，將您的個人資料傳輸至其他國家。您可以透過以下第 (N) 節部分提供的聯絡方式，索取一份我方的《標準個資保護契約條款》副本。",
                "我方使用歐洲經濟區以外的第三方資料處理者，做為提供給您之服務的一部分，如下文所述：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;管理客戶、合作夥伴和聯絡人的 Salesforce.com，總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供設備運送和服務支援的聯邦快遞 (FedEx Corporation)，總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;負責行銷活動的 The Rocket Science Group（以 Mailchimp 的名義進行交易），總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供付款服務的 PayPal Inc.，總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供雲端服務的亞馬遜網路服務公司 (Amazon Web Services, Inc.)，總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;提供雲端服務的微軟公司 (Microsoft Corporation, Microsoft Azure)，總部位於美國。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;若需要更多與歐洲經濟區以外之第三方資料處理者有關的資訊，以及獲得我方與其簽訂之資料保護協議的副本時，請透過以下第 (N) 節提供的聯絡方式與我方聯絡。"
            ]
        },
        G:{
            title:"G. 資料正確性",
            textItem:[
                "我方採取一切合理的措施，確保：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;您的個人資料準確，並在您通知我方的情況下保持最新狀態，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;我方會在收到您的通知後，刪除或更正任何不準確的個人資料。",
                "我方可能會不時要求確認您的個人資料之準確性。"
            ]
        },
        H:{
            title:"H. 資料最小化",
            textItem:"我方會採取一切合理措施，確保我方在處理的您的個人資料時，僅會處理與本隱私權注意事項規定之目的有關合理要求的個人資料。"
        },
        I:{
            title:"I. 資料保留",
            textItem:[
                "確定我方保存您的個人資料之期間的標準，如下：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;我方將以允許識別之形式保留您的個人資料副本，但是僅限與我方使用該資料之目的有關的必要時間，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;適用法律要求之更長的保留期。特別是，我方可能會在建立、行使或捍衛任何法律權利需要的任何期限內，保留您的個人資料。"
            ]
        },
        J:{
            title:"J. 保障個人資料",
            textItem:[
                "漢達精密做為個人資料的控制者，將會確保採取必要和充分的保障措施，防止未經授權存取、損失、濫用或變更您的個人資料。",
                "我方會將所有個人資訊均儲存在具有相關之存取和防火墻控制項的安全伺服器上。",
                "使用書面或電子郵件形式傳送任何個人資料給我方的傳輸過程可能不安全，我方無法保證交付。",
                "密碼必須保密，不得揭露予第三方。漢達精密不會要求您提供密碼。"
            ]
        },
        K:{
            title:"K. 資料主體權利",
            textItem:[
                "根據您的國籍（例如：歐盟公民）和住所的適用法律，您在處理您的個人資料方面可能享有部分權利，包括：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;要求存取我方處理或控制之您的個人資料或取得副本的權利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;要求修正我方處理或控制之您個人資料中之任何不準確的權利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;刪除我方處理或控制之您的個人資料，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;限制處理我方處理或控制之您的個人資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;以合法之理由，反對我方或代表我方處理您的個人資料的權利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在適用之範圍內，要求將我方處理或控制之您的個人資料轉移給另一個控制者的權利，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;在我方依據您的同意處理您的個人資料之情況下，撤回該同意的權利，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;針對我方或代表我方處理您的個人資料，向資料保護機構提出申訴的權利。",
                "將不影響您的法定權利。",
                "在想要行使上述一項或多項權利，或提出與這些權利或本隱私權注意事項中之任何其他規定，或我方處理您的個人資料有關的問題時，請使用下文第 (N) 節中提供的聯絡詳細資料。"
            ]
        },
        L:{
            title:"L. Cookie",
            textItem:"Cookie 是一種在您造訪網站（包括我方的網站）時，放置於您的裝置上的小型檔案。它會記錄與您的裝置、您的瀏覽器以及您在部分情況下的偏好和瀏覽習慣有關的資訊。根據我方的 Cookie 原則，我方可能會透過 Cookie 技術處理您的個人資料。更多與我方如何使用 Cookie 的相關資訊，請參閱我方的 Cookie 原則。"
        },
        M:{
            title:"M. 使用條款",
            textItem:"使用我方網站，即必須遵守我方的使用條款。"
        },
        N:{
            title:"N. 聯絡方式",
            textItem:"如果您對於本隱私權注意事項中的任何資訊，或與漢達精密處理個人資料有關的任何其他問題有任何意見、問題或疑慮，請聯絡：",
            contact:"11568 台灣台北市 <br/>南港區南港路一段 209 號<br/>A 棟 5 樓法務中心<br/>收件人：資料保護經理<br/>電子信箱： dpm.LAC@getac.com.tw<br/>電話：+886 (0)2 2785 7888"
        }
    },
    cookiePolicy:{
        title:"Cookie 原則",
        textItem:"本 Cookie 原則適用於列示在本原則末端，由 MPT Solution (HK) Limited 代表其本身、其子公司和其關係企業（合稱「漢達精密」）運營或控制的網站。",
        which:{
            title:"本原則適用之網站",
            textItem:[
                "本原則適用於以下由 Getac 和漢達精密經營或控制的網站。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;http://www.mpt-solution.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://de.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://en.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://es.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://fr.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://intl.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://it.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://ru.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://getac.co.uk/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://latam.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://tw.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.cn/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://apac.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://us.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://mx.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.mx/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://be.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://www.getacestore.com/<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://partners.getac.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://rma.getac.com"
            ]
        },
        what:{
            title:"什麽是 Cookie？",
            textItem:[
                "Cookie 是一種在您瀏覽一個網站時，可能會儲存在您的電腦或其他裝置上的小型文件檔案。其一般是用於使網站正常工作、追蹤您在網站中的活動、記住登入的詳細資料等。",
                "Cookie可以根據來源、功能和週期，區分為不同的類型。Cookie 的重要特徵包括以下：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;第一方 Cookie 是正在瀏覽之網站放置的 Cookie，而第三方 Cookie 是由正在瀏覽之網站以外的網站放置。 請注意，我方無法控制第三方收集或進一步使用資料。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;必要的 Cookie 在允許網站的技術操作方面具有必要性（例如：Cookie 讓您可以在網站上移動及使用其功能）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;效能 Cookie 會收集與網站效能有關的資料，例如瀏覽者的數量、在網站上花費的時間和錯誤訊息。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;功能 Cookie 會透過記住您的選擇（例如語言、地區、登入等），提高網站的可用性。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;目標／廣告 Cookie 使網站可以傳送個人化的廣告給您。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;工作階段 Cookie 是暫時性的 Cookie，會在您關閉瀏覽器時刪除，而持續性或永久性 Cookie 會保留在您的裝置上，直至手動刪除，或您的瀏覽器根據持續性 Cookie 文件中指定的持續時間進行刪除。<br/>",
                "更多與 Cookie 之各方面有關的資訊，請瀏覽 www.allaboutcookie.org。請注意，漢達精密與該第三方網站無任何關聯性，且無須為其負責。"
            ]
        },
        why:{
            title:"我方为什麽使用 Cookie？",
            textItem:[
                "我方可能会为下列目的使用 Cookie：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;區分使用者，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;改善我方網站的使用和功能，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;根據您的需要和偏好，制定我方的網站和產品，<br/>•&nbsp;&nbsp;&nbsp;&nbsp;處理您的購買訂單，以及<br/>•&nbsp;&nbsp;&nbsp;&nbsp;分析我方網站的使用方式，並編譯匿名和彙總的統計資料。<br/>",
                "我方不會使用收集的資訊建立使用者個人資料。"
            ]
        },
        whatTypes:{
            title:"我方使用哪些類型的 Cookie？",
            textItem:[
                "下表概述了本網站使用的 Cookie。",
                "請注意，與 Cookie 有關和為其他目的而處理之您的個人資料，都會受到我方的隱私權原則規範。",
                "此外，我方也可能會使用 Web 指標（或清晰的 GIF 檔）和其他類似技術，補充或結合使用 Cookie。Web 指標通常是個透明的圖形影像（通常為 1 像素 × 1 像素），放置於網站上或電子郵件中，協助我方了解我方網站之瀏覽者的行為。更多與 Web 指標有關的資訊，請瀏覽 http://www.allaboutcookie.org/web-beacons/。請注意，漢達精密與該第三方網站無任何關聯性，且無須為其負責。"
            ]
        },
        howCan:{
            title:"您如何控制 Cookie 和 Web 指標？",
            textItem:[
                "大部分的網際網路瀏覽器都會設定為自動接受 Cookie。您可以根據您的瀏覽器，將瀏覽器設定為在接受 Cookie 之前發出警告，或將其設定為拒絕接受。請參考您的瀏覽器上的「幫助」按鈕（或類似按鈕），以深入了解如何進行該動作。",
                "禁用 Cookie 可能會影響您在我方網站上的體驗。",
                "如果您使用不同的裝置造訪我方網站時，將需要確保每一部裝置的每一個瀏覽器都會設定為您的 Cookie 偏好設定。",
                "更多與管理 Cookie 之方式有關的資訊，請瀏覽：http://www.allaboutcookie.org/manage-cookie/。請注意，漢達精密與該第三方網站無任何關聯性，且無須為其負責。",
                "此外，您可以透過瀏覽以下網站及選擇想要拒絕接受的公司，以禁用其 Cookie： http://www.aboutads.info/choices/#completed 和 http://www.youronlinechoices.com/。請注意，漢達精密與這些第三方網站無任何關聯性，且無須為其負責。"
            ]
        }
    },
    termsUse:{
        title:"使用條款",
        textItem:"本使用條款（以下稱 「使用條款」）僅適用於 MPT Solution (HK) Limited 及其關係企業（以下稱「MPT Solution」）的網站 mpt-solution.com（以下稱「網站」）。請注意，本網站上之個別頁面或材料，可能具備各自的條款和條件。在使用網站上的這些頁面或材料時，必須遵守上述之個別條款和條件以及使用條款。如果使用條款的任何條件與上述個別條款和條件之間存有任何衝突時，應以該等個別條款和條件為準。",
        accessing:{
            title:"1.存取網站",
            textItem:[
                "在存取和使用本網站時，必須遵守以下使用條款與此處包含的所有條款和條件，或本網站上規定的任何個別條款和條件，且應視為您已經接受所有的這些條款。如果您不同意所有的這些使用條款，則不應使用本網站。",
                "MPT Solution 可以隨時修訂這些使用條款。此類修訂的使用條款應在本網站上公布後生效。請定期查看本網站發布的使用條款，以確保您了解與存取和使用本網站有關的所有條款。其他 MPT Solution 網站可能具有本身之適用於這些網站的使用條款。"
            ]
        },
        legal:{
            title:"2.免責聲明和責任限制",
            textItem:[
                "本網站是以「原樣」提供所有的內容和其他資訊。MPT Solution 茲此明確聲明，不任何形式提供明示或暗示的陳述或保證，包括但不限於適銷性、任何特定目的之適用性、非侵權性的保證，或本網站之運作或內容或其他資訊的保證。Mpt Solution 不針對本網站之安全性提供任何保證或陳述。您承認傳送的任何資訊可能被攔截。Mpt Solution 不保證本網站或使本網站可用的伺服器或由 Mpt Solution 傳送的電子通訊，不會包含病毒或任何其他有害元素。",
                "MPT Solution 不保證網站發布之任何資訊的準確性、可靠性或及時性，且不為與本網站連結的任何內容、觀點、產品或服務背書，以及不對因依賴這些資訊之準確性、可靠性或及時性，而造成的任何損失負責。這些資訊的部分內容可能是不正確的或不是最新的。任何依賴從本網站獲得的任何資訊的個人或實體都要承擔自身的風險。",
                "MPT Solution 保留在任何時候變更或更新本網站的任何和所有內容或資訊或其格式的權利，且無需事先通知。MPT Solution 自行決定保留以任何理由終止或限制您存取本網站的權利。",
                "在任何情況下，MPT Solution 或其任何關係企業均不對任何直接、間接、後果性、懲罰性、特殊或偶然的損害（包括但不限於業務、合約、收入、資料、資訊損失或業務中斷的損害），或因使用或無法使用本網站或其內容而引起的或與之有關的損失負責，即使 MTP Solution 已知可能會發生此類損失亦同。任何針對 MPT Solution 提起或與本網站有關的訴訟，都必須在訴訟理由產生後一年內開始，並書面通知 MPT Solution。如果您因為使用本網站之內容、資訊或服務，而導致需要維護、修理或更正設備或資料時，應自行承擔所有的相關費用。",
                "本網站可能會提供其他不受 MPT Solution 控制的網站的連結。MPT Solution 對此類其他網站的內容，概不負責。MPT Solution 提供此類連結僅是為了方便本網站的使用者，因此包含任何此類網站的連結，不代表 MPT Solution 認可此類網站的內容。"
            ]
        },
        copyright:{
            title:"3.著作權",
            textItem:"本網站及其中提到的所有材料，包括但不限於軟體、音訊、影片、文字、影像和照片（以下稱 「內容」）的著作權和所有其他所有權，均歸屬於 MPT Solution、其關係企業或其授權人。保留此處未明確授予之內容中的所有權利。除另有規定外，本網站發布的內容得以未經修改的形式複製或分發，僅供個人非商業使用。未經 MPT Solution 事前書面同意，嚴格禁止以任何其他方式使用內容，包括但不限於分發、複製、修改、展示或傳輸。應在所有複製品上保留所有的著作權和其他的所有權聲明。"
        },
        trademark:{
            title:"4.商標、商號、商業外觀、著作權和智慧財產權",
            textItem:[
                "MPT Solution 的商標、商號、商業外觀、著作權和智慧財產權均為寶貴的資產，且我方致力於努力保護它們。因此，未經 MPT Solution 事前正式書面允許，任何經銷商、分銷商或集成商皆不得使用任何方式玷汙或改變任何 MPT Solution 產品或包裝，特別是刪除、改變或掩蓋其中的 MPT Solution 標誌或其他所有權通知，且嚴格禁止。任何未經授權將產品重新命名或重新黏貼標籤，以及導致習慣上識別產品的術語消失的行為，均已侵犯 MPT Solution 的智慧財產權和權利。",
                "如果您在商標、商號、商業外觀、著作權和智慧財產權方面有任何疑問時，請將您的疑問提交給 MPT Solution。"
            ]
        },
        governing:{
            title:"5..管轄法律和管轄權",
            textItem:"本使用條款應以中華民國法律為準據法，並依其解釋，不考慮其法律衝突原則。您與 MPT Solution 之間因本網站引起或與本網站有關的任何索賠或爭議，均應受中華民國台灣台北地方法院專屬管轄。"
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/cht.js